import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environment';
import { IAttachmentsFilesDTO } from '../_interfaces/medical-tests/i-medical-test-details';
import {GenericResponse, PaginatedResponse, Response, SuccessResponse} from 'src/app/_models/response.model';
import { ITestRequest, TestRequest } from '../_models/test-request.model';

@Injectable({
  providedIn: 'root'
})
export class TestRequestService {

  testReqUrl = 'api/AdminTestRequests';
  getAllTestRequestsUrl = 'api/AdminEhrTestRequests/GetAllTestRequests';
  getTestRequestsByTypeIdUrl = 'api/AdminEhrTestRequests/GetTestRequestsByTypeId';
  uploadTestRequestResultsUrl = 'api/AdminEhrTestRequests/UploadResultToTestRequest';
  uploadTestRequestDetailsResultsUrl = 'api/AdminEhrTestRequestDetails/UploadTestRequestDetailResults';
  exportExcelUrl = 'api/AdminEhrTestRequests/GetAllTestRequestsExcel';
  generatePaymobQuickPaymentLinkUrl = 'api/AdminEhrTestRequests/GeneratePaymobQuickPaymentLink';

  constructor(private http: HttpClient) { }

  getAllServices(padeNumber): Observable<any> {
    return this.http.get(this.testReqUrl + '?page=' + padeNumber);
  }

  getAllTestRequests(currentPage, pageSize): Observable<PaginatedResponse<ITestRequest>> {
    let params = new HttpParams()
        .set('pageSize', pageSize)
        .set('currentPage', currentPage);

    return this.http.get<PaginatedResponse<ITestRequest>>(this.getAllTestRequestsUrl, {params: params});
  }

  getExportExcel(typeId): Observable<GenericResponse<TestRequest[]>>{
    let params = new HttpParams().set('typeId',typeId);
    return this.http.get<GenericResponse<TestRequest[]>>(this.exportExcelUrl, {params})
  }

  getTestRequestsByType(currentPage, pageSize, typeId): Observable<PaginatedResponse<ITestRequest>> {
    let params = new HttpParams()
        .set('pageSize', pageSize)
        .set('currentPage', currentPage)
        .set('typeId', typeId);

    return this.http.get<PaginatedResponse<ITestRequest>>(this.getTestRequestsByTypeIdUrl, {params: params});
  }

  uploadTestResult(testResult): Observable<any> {
    const formData = new FormData();
    formData.append('Result', testResult.result, testResult.result.name);
    formData.append('id', testResult.id);

    return this.http.put(`${this.testReqUrl}/UploadResult`, formData);
  }

  uploadTestRequestResult(testRequestId, resultFiles): Observable<GenericResponse<IAttachmentsFilesDTO>> {
    let formData = new FormData();
    formData.append('id', testRequestId);
    resultFiles.forEach((file) => { formData.append('files', file); })

    return this.http.put<GenericResponse<IAttachmentsFilesDTO>>(this.uploadTestRequestResultsUrl, formData);
  }

  uploadTestRequestDetailsResult(testRequestDetialsId, resultFiles): Observable<any> {
    let formData = new FormData();
    formData.append('id', testRequestDetialsId);
    resultFiles.forEach((file) => { formData.append('files', file); })

    return this.http.put(this.uploadTestRequestDetailsResultsUrl, formData);
  }

  generatePaymobQuickPaymentLink(ehrTransactionId: number): Observable<any> {
    return this.http.post<GenericResponse<SuccessResponse>>(this.generatePaymobQuickPaymentLinkUrl, {ehrTransactionId});
  }
}
